import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  dialog: {
    "& .MuiDialogActions-root": {
      display: "flex",
      alignItem: "center",
      justifyContent: "flex-start",
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    "& .MuiDialogTitle-root": {
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(3),
    },
  },
  dialogContent: {
    padding: 24,
    "& .MuiTypography-root": {
      fontFamily: "Lato",
      color: "#333",
      fontSize: theme.typography.pxToRem(16),
    },
  },
  dialogActions: {
    padding: "10px 0",
    margin: "18px 0",
    justifyContent: "flex-end!important",
    "& .MuiButtonBase-root": {
      borderRadius: "100px!important",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column-reverse",
    },
  },
  btnCancel: {
    color: "#0344DC",
    border: "none",
    padding: "8px 24px",
    fontFamily: "Inter",
    "&:hover": {
      backgroundColor: "#F1F5FF",
      border: "none",
      color: "#0344DC",
    },
  },
  btnConfirm: {
    backgroundColor: "#0344DC",
    color: "white",
    padding: "8px 24px",
    fontFamily: "Inter",
    textTransform: "none",
    "&:hover": {
      color: "white",
      backgroundColor: "#0236B0",
    },
    "&:active": {
      backgroundColor: "#022984",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "12px",
    },
  },
  dialogTitle: {
    maxWidth: "80%",
    "& .MuiTypography-root": {
      color: "black",
      padding: "12px 0",
      fontSize: theme.typography.pxToRem(20),
      fontFamily: "Lato",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "8px !important",
      alignSelf: "center",
    },
  },
  bigModal: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "90%",
    },
  },
  modalText: {
    fontFamily: "Lato",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  btn: {
    textTransform: "none",
    marginRight: theme.spacing(1),
  },
}));
